var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('car-introduction'),_c('chartered-car',{attrs:{"id":"chartered"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }